// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/react-scripts/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/react-scripts/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.modal {
    display: flex;
    flex-direction: column;
    position: fixed;
    z-index: 300;
    left: 0;
    top: 0;
    width: 100%;
    height: 100%;
    background-color: rgba(0, 0, 0, 0.5);
    justify-content:space-evenly; /* This fixes the issue of a tall modal <3 */
    align-items: center;
    overflow: auto; /* Enable scroll for the entire modal */
}

.modal-content {
    box-sizing: border-box;
    background-color: #fff;
    border: 1px solid #888;
    padding: 2rem;
    min-width: 50%;
    max-width: 90%;
    width: -moz-fit-content;
    width: fit-content;
    border-radius: 3px;
    overflow-y:visible; /* Enable dropdown overflow */
    pointer-events: auto; /* Allow interaction with the modal content */
    position: relative;
}

.modal-item-name {
    margin-left: 2rem;
    margin-right: auto;
}

.modal-item-name .input {
    width: 18rem; /* Set a specific width */
}

.modal-tabs {
    width: 100%;
    margin-top: 1rem;
    list-style: none;
    background: none;
    border-bottom: 1px solid rgb(131, 144, 175);
}

.modal-body {
    margin-top: 2rem;
}

.tab-button {
    position: relative;
    background: none;
    display: inline-flex;
    align-items: center;
    height: 3rem;
    color: rgb(91, 105, 135);
    font-weight: 600;
    padding: 0 1rem;
    border: 1px solid transparent;
    border-radius: 3px 3px 0px 0px;
    margin-bottom: -1px;
}

.tab-button:hover {
    background-color: rgb(243, 245, 249);
    border-bottom-color: rgb(131, 144, 175);
}

.tab-button:focus {
    outline: rgb(91, 105, 135) dotted 2px;
    outline-offset: 2px;
}

.tab-button-active {
    color: rgb(3, 27, 78);
    border-width: 1px;
    border-style: solid;
    border-color: rgb(131, 144, 175) rgb(131, 144, 175) white;
}

.tab-button-active:hover {
    border-color: rgb(131, 144, 175) rgb(131, 144, 175) white;
}

.calculation-container {
    background: #fff;
    border-radius: 3px;
    color: #333;
    text-align: center;
    border: 1px solid #dfdfdf;
    position: relative;
    box-sizing: border-box;
    display: block;
    height: auto;
    cursor: pointer;
}

.calculation-container-price {
    padding: .8rem 1rem;
    border-bottom: 1px solid #dfdfdf;
    color: #5b6987;
    font-size: .8rem;
    flex-direction: column;
    gap: .2rem; 
}

.calculation-container:hover {
    border-color: #cbcbcb;
    background: #f1f1f1;
}

.calculation-container:hover .calculation-container-price {
    border-bottom-color: #cbcbcb;
}

.calculation-container:focus-within {
    border-color: #0069ff;
}

.calculation-container:focus-within .calculation-container-price {
    border-bottom-color: #0069ff;
    background: #f5f9ff;
    color: #0069ff;
    border-top-left-radius: 3px;
    border-top-right-radius: 3px;
}

.calculation-container-input {
    position: relative;
    background: #fff;
    border-radius: 3px;
}

.calculation-container-input:focus-within .floatlabel-price {
    opacity: 1;
}

.calculation-container-input:focus-within input {
    padding-top: 1.4rem;
    padding-bottom: 0.6rem;
}

/* Hide placeholder text when the input container is focused within */
.calculation-container-input:focus-within input::placeholder {
    opacity: 0;
}
  
.calculation-container-input input {
    width: 100%;
    text-align: center;
    margin: 1px 0;
    border: none;
    outline: none;
    padding: 1rem 0;
    font-size: 0.9rem;
}

.card {
    border-radius: 3px;
    box-shadow: rgba(3, 27, 78, 0.16) 0px 1px 2px, rgba(3, 27, 78, 0.2) 0px 1px 3px;
    transition: box-shadow 0.25s cubic-bezier(0.645, 0.045, 0.355, 1) 0s;
    position: relative;
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    align-items: flex-start;
    background-color: rgb(255, 255, 255);
    width: 50%;
    min-width: -moz-fit-content;
    min-width: fit-content;
    max-width: 100%;
    box-sizing: border-box; /* Ensure the card itself includes padding and border in its width */
    margin-bottom: 1.3rem;
    margin-top:1.3rem;

}

.card-header {
    background: transparent;
    flex-flow: wrap;
    -webkit-box-align: center;
    -webkit-box-pack: justify;
    width: 100%;
    padding: 1.5rem 1.5rem 1rem;
    box-sizing: border-box; /* Ensure the header includes padding in its width */
}

.card-body {
    background: transparent;
    padding: .5rem 1.5rem 1rem;
}

.modal-content .card-header h5 {
    margin: 0;
}

.floatlabel-price {
    position: absolute;
    top: 6px;
    left: 10px;
    font-size: 11px;
    font-weight: 700;
    color: #676767;
    padding-left: 5px;
    display: block;
    opacity: 0;
    transition: all .2s ease-in-out;
}

.modal-footer {
    margin-top: 2rem;
}

.modal-footer .dollar,
.modal-footer .cost,
.modal-footer .period {
    color: rgb(3, 27, 78);
}

.radio-button {
    border: 1px solid #dfdfdf;
    padding: 1rem 2rem 1rem 3rem;
    position: relative;
    cursor: pointer;
    text-align: left;
    border-radius: 3px;
    transition: background-color 0.3s ease;
}

.radio-button::before {
    border: 1px solid #5b6987;
    width: 1rem;
    height: 1rem;
    content: '';
    background: #fff;
    position: absolute;
    border-radius: 50%;
    top: 50%;
    margin-top: -.5rem;
    left: 1rem;
    box-sizing: border-box;    
}

.radio-button:hover {
    background-color: #fafafa;
}

.radio-button-active, 
.radio-button-active:hover {
    background-color: #f3f8ff;
    border-color: #0069ff;
}

.radio-button-active::before {
    border-color: #007bff;
    background-color: #007bff;

}

.radio-button-active::after {
    content: ''; /* Ensure the pseudo-element is created */
    position: absolute; /* Ensure correct positioning */
    width: .5rem; /* Define the size */
    height: .5rem;
    background: #fff;
    border-radius: 50%; /* Make it circular */
    top: 50%;
    left: 1.25rem;
    margin-top: -.25rem; /* Center it vertically */
}

.dropdown {
    position: absolute;
    background-color: #fff;
    border: 1px solid #ddd;
    max-height: 16rem;
    overflow-y: auto;
    margin-top: 1px;
    border-radius: 3px;
    z-index: 200;
    width: 100%;
    box-sizing: border-box;
}

.dropdown li {
    padding: 1px .5rem;
}

.dropdown li:hover {
    background-color: #f0f0f0;
}

.dropdown-plans-description {
    width: 21rem;
}

.dropdown-plans-specifications {
    margin-right: auto;
}

.dropdown-plans-price {
    line-height: 1rem;
    min-width: -moz-fit-content;
    min-width: fit-content;
}

.scaler-container {
    all: unset;
    display: grid;
    grid-template-columns: 48px auto 48px;  /* Adjust 'auto' based on the middle content width */
    grid-template-areas: "down input up";
    min-width: 100px;
    max-width: 250px;
}

.stepper-container {
    all: unset;
    display: grid;
    grid-template-columns: auto 36px;
    grid-template-areas: "input up" "input down";
    min-width: 100px;
    max-width: 150px;
}

.scaler-input-wrapper,
.stepper-input-wrapper {
    grid-area: input;
}

.scaler-input,
.stepper-input {
    width: 100%;
    min-width: 5rem;
    display: flex;
    height: 48px;
    position: relative;
    box-sizing: border-box;
    background-color: rgb(255, 255, 255);
    cursor: text;
    padding: 0;
    gap: 16px;
    border: 1px solid rgb(91, 105, 135);
}

.stepper-input {
    border-radius: 3px 0 0 3px;
}

.scaler-input-field,
.stepper-input-field {
    transition: all 0.25s cubic-bezier(0.645, 0.045, 0.355, 1);
    box-sizing: border-box;
    background-color: unset;
    outline: none;
    width: 100%;
    height: 100%;
    display: block;
    border: unset;
    box-shadow: unset;
    line-height: 1.5;
    resize: none;
    text-align: center;
    padding: 0 16px;
}

.stepper-input-field {
    border-radius: 3px 0 0 3px;
}

.scaler-input-field:focus,
.stepper-input-field:focus {
    outline: rgb(91, 105, 135) dotted 2px;
    outline-offset: 2px;
    z-index: 2;
}

.scaler-input-field:hover:not(:disabled),
.stepper-input-field:hover:not(:disabled) {
    border-color: rgb(0, 97, 235);
}

.scaler-input-field:disabled,
.stepper-input-field:disabled {
    cursor: unset;
    opacity: 0.3;
    outline: none;
}

/* Remove spinner (up and down arrows) in WebKit-based browsers (e.g., Chrome, Safari) */
.scaler-input-field::-webkit-inner-spin-button,
.stepper-input-field::-webkit-inner-spin-button {
    appearance: none;
    -moz-appearance: textfield; /* Remove spinner in Firefox */
}

.scaler-button-wrapper-up,
.stepper-button-wrapper-up {
    grid-area: up;
}

.scaler-button-wrapper-down,
.stepper-button-wrapper-down {
    grid-area: down;
}

.stepper-button-wrapper-down {
    grid-area: down;
    border-top: 1px solid rgb(91, 105, 135); /* Keep this border immune to opacity if increment or decrement button is :disabled */
}

.scaler-button-increment,
.scaler-button-decrement,
.stepper-button-increment,
.stepper-button-decrement {
    all: unset;
    width: 100%;
    height: 100%;
    position: relative;
    display: flex;
    align-items: center;
    justify-content: center;
    box-sizing: border-box;
    background-color: rgb(255, 255, 255);
    cursor: pointer;
    border-style: solid;
    border-image: initial;
    padding: 0;
    color: rgb(91, 105, 135);
}

.scaler-button-increment {
    transition: all 0.25s cubic-bezier(0.645, 0.045, 0.355, 1);
    border-right: 1px solid rgb(91, 105, 135);
    border-top: 1px solid rgb(91, 105, 135);
    border-left: none;
    border-bottom: 1px solid rgb(91, 105, 135);
    border-top-right-radius: 3px;
    border-bottom-right-radius: 3px;
}

.stepper-button-increment {
    transition: all 0.25s cubic-bezier(0.645, 0.045, 0.355, 1);
    border-right: 1px solid rgb(91, 105, 135);
    border-top: 1px solid rgb(91, 105, 135);
    border-left: none;
    border-bottom: none;
    border-top-right-radius: 3px;
    border-bottom-right-radius: 0;
}

.stepper-button-decrement {
    transition: all 0.25s cubic-bezier(0.645, 0.045, 0.355, 1);
    border-right: 1px solid rgb(91, 105, 135);
    border-bottom: 1px solid rgb(91, 105, 135);
    border-left: none;
    border-top: none;
    border-bottom-right-radius: 3px;
}

.scaler-button-decrement {
    transition: all 0.25s cubic-bezier(0.645, 0.045, 0.355, 1);
    border-right: none;
    border-bottom: 1px solid rgb(91, 105, 135);
    border-left: 1px solid rgb(91, 105, 135);
    border-top: 1px solid rgb(91, 105, 135);
    border-top-left-radius: 3px;
    border-bottom-left-radius: 3px;
}

.scaler-button-increment:hover:not(:disabled),
.scaler-button-decrement:hover:not(:disabled),
.stepper-button-increment:hover,
.stepper-button-decrement:hover {
    background-color: rgb(243, 245, 249);
}

.scaler-button-increment:focus,
.scaler-button-decrement:focus,
.stepper-button-increment:focus,
.stepper-button-decrement:focus {
    outline: rgb(91, 105, 135) dotted 2px;
    outline-offset: 2px;
    z-index: 2;
}

.scaler-button-increment:active:not(:disabled),
.scaler-button-decrement:active:not(:disabled)
.stepper-button-increment:active:not(:disabled),
.stepper-button-decrement:active:not(:disabled) {
    color: rgb(0, 97, 235);
    border-color: rgb(0, 97, 235);
    background-color: rgb(243, 248, 255);
    fill: rgb(0, 97, 235); /* Color for the arrow */
}

.scaler-button-increment:disabled,
.scaler-button-decrement:disabled {
    cursor: unset;
    fill-opacity: 0.3;
    outline: none;
}


.stepper-button-increment:disabled,
.stepper-button-decrement:disabled {
    cursor: unset;
    opacity: 0.3;
    outline: none;
}

.scaler-icon-up,
.scaler-icon-down,
.stepper-icon-up,
.stepper-icon-down {
    height: .65em;
    width: .65em;
}

.search-container .input {
    display: block;
    width: 100%;
}

.alert-info {
    height: 1.4em;
    width: 1.4em;
}`, "",{"version":3,"sources":["webpack://./src/Modal.css"],"names":[],"mappings":"AAAA;IACI,aAAa;IACb,sBAAsB;IACtB,eAAe;IACf,YAAY;IACZ,OAAO;IACP,MAAM;IACN,WAAW;IACX,YAAY;IACZ,oCAAoC;IACpC,4BAA4B,EAAE,4CAA4C;IAC1E,mBAAmB;IACnB,cAAc,EAAE,uCAAuC;AAC3D;;AAEA;IACI,sBAAsB;IACtB,sBAAsB;IACtB,sBAAsB;IACtB,aAAa;IACb,cAAc;IACd,cAAc;IACd,uBAAkB;IAAlB,kBAAkB;IAClB,kBAAkB;IAClB,kBAAkB,EAAE,6BAA6B;IACjD,oBAAoB,EAAE,6CAA6C;IACnE,kBAAkB;AACtB;;AAEA;IACI,iBAAiB;IACjB,kBAAkB;AACtB;;AAEA;IACI,YAAY,EAAE,yBAAyB;AAC3C;;AAEA;IACI,WAAW;IACX,gBAAgB;IAChB,gBAAgB;IAChB,gBAAgB;IAChB,2CAA2C;AAC/C;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,kBAAkB;IAClB,gBAAgB;IAChB,oBAAoB;IAEpB,mBAAmB;IACnB,YAAY;IACZ,wBAAwB;IACxB,gBAAgB;IAChB,eAAe;IACf,6BAA6B;IAC7B,8BAA8B;IAC9B,mBAAmB;AACvB;;AAEA;IACI,oCAAoC;IACpC,uCAAuC;AAC3C;;AAEA;IACI,qCAAqC;IACrC,mBAAmB;AACvB;;AAEA;IACI,qBAAqB;IACrB,iBAAiB;IACjB,mBAAmB;IACnB,yDAAyD;AAC7D;;AAEA;IACI,yDAAyD;AAC7D;;AAEA;IACI,gBAAgB;IAChB,kBAAkB;IAClB,WAAW;IACX,kBAAkB;IAClB,yBAAyB;IACzB,kBAAkB;IAClB,sBAAsB;IACtB,cAAc;IACd,YAAY;IACZ,eAAe;AACnB;;AAEA;IACI,mBAAmB;IACnB,gCAAgC;IAChC,cAAc;IACd,gBAAgB;IAChB,sBAAsB;IACtB,UAAU;AACd;;AAEA;IACI,qBAAqB;IACrB,mBAAmB;AACvB;;AAEA;IACI,4BAA4B;AAChC;;AAEA;IACI,qBAAqB;AACzB;;AAEA;IACI,4BAA4B;IAC5B,mBAAmB;IACnB,cAAc;IACd,2BAA2B;IAC3B,4BAA4B;AAChC;;AAEA;IACI,kBAAkB;IAClB,gBAAgB;IAChB,kBAAkB;AACtB;;AAEA;IACI,UAAU;AACd;;AAEA;IACI,mBAAmB;IACnB,sBAAsB;AAC1B;;AAEA,qEAAqE;AACrE;IACI,UAAU;AACd;;AAEA;IACI,WAAW;IACX,kBAAkB;IAClB,aAAa;IACb,YAAY;IACZ,aAAa;IACb,eAAe;IACf,iBAAiB;AACrB;;AAEA;IACI,kBAAkB;IAClB,+EAA+E;IAC/E,oEAAoE;IACpE,kBAAkB;IAClB,aAAa;IACb,sBAAsB;IAEtB,2BAA2B;IAC3B,uBAAuB;IACvB,oCAAoC;IACpC,UAAU;IACV,2BAAsB;IAAtB,sBAAsB;IACtB,eAAe;IACf,sBAAsB,EAAE,oEAAoE;IAC5F,qBAAqB;IACrB,iBAAiB;;AAErB;;AAEA;IACI,uBAAuB;IACvB,eAAe;IACf,yBAAyB;IACzB,yBAAyB;IACzB,WAAW;IACX,2BAA2B;IAC3B,sBAAsB,EAAE,oDAAoD;AAChF;;AAEA;IACI,uBAAuB;IACvB,0BAA0B;AAC9B;;AAEA;IACI,SAAS;AACb;;AAEA;IACI,kBAAkB;IAClB,QAAQ;IACR,UAAU;IACV,eAAe;IACf,gBAAgB;IAChB,cAAc;IACd,iBAAiB;IACjB,cAAc;IACd,UAAU;IACV,+BAA+B;AACnC;;AAEA;IACI,gBAAgB;AACpB;;AAEA;;;IAGI,qBAAqB;AACzB;;AAEA;IACI,yBAAyB;IACzB,4BAA4B;IAC5B,kBAAkB;IAClB,eAAe;IACf,gBAAgB;IAChB,kBAAkB;IAClB,sCAAsC;AAC1C;;AAEA;IACI,yBAAyB;IACzB,WAAW;IACX,YAAY;IACZ,WAAW;IACX,gBAAgB;IAChB,kBAAkB;IAClB,kBAAkB;IAClB,QAAQ;IACR,kBAAkB;IAClB,UAAU;IACV,sBAAsB;AAC1B;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;;IAEI,yBAAyB;IACzB,qBAAqB;AACzB;;AAEA;IACI,qBAAqB;IACrB,yBAAyB;;AAE7B;;AAEA;IACI,WAAW,EAAE,yCAAyC;IACtD,kBAAkB,EAAE,+BAA+B;IACnD,YAAY,EAAE,oBAAoB;IAClC,aAAa;IACb,gBAAgB;IAChB,kBAAkB,EAAE,qBAAqB;IACzC,QAAQ;IACR,aAAa;IACb,mBAAmB,EAAE,yBAAyB;AAClD;;AAEA;IACI,kBAAkB;IAClB,sBAAsB;IACtB,sBAAsB;IACtB,iBAAiB;IACjB,gBAAgB;IAChB,eAAe;IACf,kBAAkB;IAClB,YAAY;IACZ,WAAW;IACX,sBAAsB;AAC1B;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,iBAAiB;IACjB,2BAAsB;IAAtB,sBAAsB;AAC1B;;AAEA;IACI,UAAU;IACV,aAAa;IACb,qCAAqC,GAAG,oDAAoD;IAC5F,oCAAoC;IACpC,gBAAgB;IAChB,gBAAgB;AACpB;;AAEA;IACI,UAAU;IACV,aAAa;IACb,gCAAgC;IAChC,4CAA4C;IAC5C,gBAAgB;IAChB,gBAAgB;AACpB;;AAEA;;IAEI,gBAAgB;AACpB;;AAEA;;IAEI,WAAW;IACX,eAAe;IACf,aAAa;IACb,YAAY;IACZ,kBAAkB;IAClB,sBAAsB;IACtB,oCAAoC;IACpC,YAAY;IACZ,UAAU;IACV,SAAS;IACT,mCAAmC;AACvC;;AAEA;IACI,0BAA0B;AAC9B;;AAEA;;IAEI,0DAA0D;IAC1D,sBAAsB;IACtB,uBAAuB;IACvB,aAAa;IACb,WAAW;IACX,YAAY;IACZ,cAAc;IACd,aAAa;IACb,iBAAiB;IACjB,gBAAgB;IAChB,YAAY;IACZ,kBAAkB;IAClB,eAAe;AACnB;;AAEA;IACI,0BAA0B;AAC9B;;AAEA;;IAEI,qCAAqC;IACrC,mBAAmB;IACnB,UAAU;AACd;;AAEA;;IAEI,6BAA6B;AACjC;;AAEA;;IAEI,aAAa;IACb,YAAY;IACZ,aAAa;AACjB;;AAEA,wFAAwF;AACxF;;IAEI,gBAAgB;IAChB,0BAA0B,EAAE,8BAA8B;AAC9D;;AAEA;;IAEI,aAAa;AACjB;;AAEA;;IAEI,eAAe;AACnB;;AAEA;IACI,eAAe;IACf,uCAAuC,EAAE,qFAAqF;AAClI;;AAEA;;;;IAII,UAAU;IACV,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,sBAAsB;IACtB,oCAAoC;IACpC,eAAe;IACf,mBAAmB;IACnB,qBAAqB;IACrB,UAAU;IACV,wBAAwB;AAC5B;;AAEA;IACI,0DAA0D;IAC1D,yCAAyC;IACzC,uCAAuC;IACvC,iBAAiB;IACjB,0CAA0C;IAC1C,4BAA4B;IAC5B,+BAA+B;AACnC;;AAEA;IACI,0DAA0D;IAC1D,yCAAyC;IACzC,uCAAuC;IACvC,iBAAiB;IACjB,mBAAmB;IACnB,4BAA4B;IAC5B,6BAA6B;AACjC;;AAEA;IACI,0DAA0D;IAC1D,yCAAyC;IACzC,0CAA0C;IAC1C,iBAAiB;IACjB,gBAAgB;IAChB,+BAA+B;AACnC;;AAEA;IACI,0DAA0D;IAC1D,kBAAkB;IAClB,0CAA0C;IAC1C,wCAAwC;IACxC,uCAAuC;IACvC,2BAA2B;IAC3B,8BAA8B;AAClC;;AAEA;;;;IAII,oCAAoC;AACxC;;AAEA;;;;IAII,qCAAqC;IACrC,mBAAmB;IACnB,UAAU;AACd;;AAEA;;;;IAII,sBAAsB;IACtB,6BAA6B;IAC7B,oCAAoC;IACpC,qBAAqB,EAAE,wBAAwB;AACnD;;AAEA;;IAEI,aAAa;IACb,iBAAiB;IACjB,aAAa;AACjB;;;AAGA;;IAEI,aAAa;IACb,YAAY;IACZ,aAAa;AACjB;;AAEA;;;;IAII,aAAa;IACb,YAAY;AAChB;;AAEA;IACI,cAAc;IACd,WAAW;AACf;;AAEA;IACI,aAAa;IACb,YAAY;AAChB","sourcesContent":[".modal {\n    display: flex;\n    flex-direction: column;\n    position: fixed;\n    z-index: 300;\n    left: 0;\n    top: 0;\n    width: 100%;\n    height: 100%;\n    background-color: rgba(0, 0, 0, 0.5);\n    justify-content:space-evenly; /* This fixes the issue of a tall modal <3 */\n    align-items: center;\n    overflow: auto; /* Enable scroll for the entire modal */\n}\n\n.modal-content {\n    box-sizing: border-box;\n    background-color: #fff;\n    border: 1px solid #888;\n    padding: 2rem;\n    min-width: 50%;\n    max-width: 90%;\n    width: fit-content;\n    border-radius: 3px;\n    overflow-y:visible; /* Enable dropdown overflow */\n    pointer-events: auto; /* Allow interaction with the modal content */\n    position: relative;\n}\n\n.modal-item-name {\n    margin-left: 2rem;\n    margin-right: auto;\n}\n\n.modal-item-name .input {\n    width: 18rem; /* Set a specific width */\n}\n\n.modal-tabs {\n    width: 100%;\n    margin-top: 1rem;\n    list-style: none;\n    background: none;\n    border-bottom: 1px solid rgb(131, 144, 175);\n}\n\n.modal-body {\n    margin-top: 2rem;\n}\n\n.tab-button {\n    position: relative;\n    background: none;\n    display: inline-flex;\n    -webkit-box-align: center;\n    align-items: center;\n    height: 3rem;\n    color: rgb(91, 105, 135);\n    font-weight: 600;\n    padding: 0 1rem;\n    border: 1px solid transparent;\n    border-radius: 3px 3px 0px 0px;\n    margin-bottom: -1px;\n}\n\n.tab-button:hover {\n    background-color: rgb(243, 245, 249);\n    border-bottom-color: rgb(131, 144, 175);\n}\n\n.tab-button:focus {\n    outline: rgb(91, 105, 135) dotted 2px;\n    outline-offset: 2px;\n}\n\n.tab-button-active {\n    color: rgb(3, 27, 78);\n    border-width: 1px;\n    border-style: solid;\n    border-color: rgb(131, 144, 175) rgb(131, 144, 175) white;\n}\n\n.tab-button-active:hover {\n    border-color: rgb(131, 144, 175) rgb(131, 144, 175) white;\n}\n\n.calculation-container {\n    background: #fff;\n    border-radius: 3px;\n    color: #333;\n    text-align: center;\n    border: 1px solid #dfdfdf;\n    position: relative;\n    box-sizing: border-box;\n    display: block;\n    height: auto;\n    cursor: pointer;\n}\n\n.calculation-container-price {\n    padding: .8rem 1rem;\n    border-bottom: 1px solid #dfdfdf;\n    color: #5b6987;\n    font-size: .8rem;\n    flex-direction: column;\n    gap: .2rem; \n}\n\n.calculation-container:hover {\n    border-color: #cbcbcb;\n    background: #f1f1f1;\n}\n\n.calculation-container:hover .calculation-container-price {\n    border-bottom-color: #cbcbcb;\n}\n\n.calculation-container:focus-within {\n    border-color: #0069ff;\n}\n\n.calculation-container:focus-within .calculation-container-price {\n    border-bottom-color: #0069ff;\n    background: #f5f9ff;\n    color: #0069ff;\n    border-top-left-radius: 3px;\n    border-top-right-radius: 3px;\n}\n\n.calculation-container-input {\n    position: relative;\n    background: #fff;\n    border-radius: 3px;\n}\n\n.calculation-container-input:focus-within .floatlabel-price {\n    opacity: 1;\n}\n\n.calculation-container-input:focus-within input {\n    padding-top: 1.4rem;\n    padding-bottom: 0.6rem;\n}\n\n/* Hide placeholder text when the input container is focused within */\n.calculation-container-input:focus-within input::placeholder {\n    opacity: 0;\n}\n  \n.calculation-container-input input {\n    width: 100%;\n    text-align: center;\n    margin: 1px 0;\n    border: none;\n    outline: none;\n    padding: 1rem 0;\n    font-size: 0.9rem;\n}\n\n.card {\n    border-radius: 3px;\n    box-shadow: rgba(3, 27, 78, 0.16) 0px 1px 2px, rgba(3, 27, 78, 0.2) 0px 1px 3px;\n    transition: box-shadow 0.25s cubic-bezier(0.645, 0.045, 0.355, 1) 0s;\n    position: relative;\n    display: flex;\n    flex-direction: column;\n    -webkit-box-pack: start;\n    justify-content: flex-start;\n    align-items: flex-start;\n    background-color: rgb(255, 255, 255);\n    width: 50%;\n    min-width: fit-content;\n    max-width: 100%;\n    box-sizing: border-box; /* Ensure the card itself includes padding and border in its width */\n    margin-bottom: 1.3rem;\n    margin-top:1.3rem;\n\n}\n\n.card-header {\n    background: transparent;\n    flex-flow: wrap;\n    -webkit-box-align: center;\n    -webkit-box-pack: justify;\n    width: 100%;\n    padding: 1.5rem 1.5rem 1rem;\n    box-sizing: border-box; /* Ensure the header includes padding in its width */\n}\n\n.card-body {\n    background: transparent;\n    padding: .5rem 1.5rem 1rem;\n}\n\n.modal-content .card-header h5 {\n    margin: 0;\n}\n\n.floatlabel-price {\n    position: absolute;\n    top: 6px;\n    left: 10px;\n    font-size: 11px;\n    font-weight: 700;\n    color: #676767;\n    padding-left: 5px;\n    display: block;\n    opacity: 0;\n    transition: all .2s ease-in-out;\n}\n\n.modal-footer {\n    margin-top: 2rem;\n}\n\n.modal-footer .dollar,\n.modal-footer .cost,\n.modal-footer .period {\n    color: rgb(3, 27, 78);\n}\n\n.radio-button {\n    border: 1px solid #dfdfdf;\n    padding: 1rem 2rem 1rem 3rem;\n    position: relative;\n    cursor: pointer;\n    text-align: left;\n    border-radius: 3px;\n    transition: background-color 0.3s ease;\n}\n\n.radio-button::before {\n    border: 1px solid #5b6987;\n    width: 1rem;\n    height: 1rem;\n    content: '';\n    background: #fff;\n    position: absolute;\n    border-radius: 50%;\n    top: 50%;\n    margin-top: -.5rem;\n    left: 1rem;\n    box-sizing: border-box;    \n}\n\n.radio-button:hover {\n    background-color: #fafafa;\n}\n\n.radio-button-active, \n.radio-button-active:hover {\n    background-color: #f3f8ff;\n    border-color: #0069ff;\n}\n\n.radio-button-active::before {\n    border-color: #007bff;\n    background-color: #007bff;\n\n}\n\n.radio-button-active::after {\n    content: ''; /* Ensure the pseudo-element is created */\n    position: absolute; /* Ensure correct positioning */\n    width: .5rem; /* Define the size */\n    height: .5rem;\n    background: #fff;\n    border-radius: 50%; /* Make it circular */\n    top: 50%;\n    left: 1.25rem;\n    margin-top: -.25rem; /* Center it vertically */\n}\n\n.dropdown {\n    position: absolute;\n    background-color: #fff;\n    border: 1px solid #ddd;\n    max-height: 16rem;\n    overflow-y: auto;\n    margin-top: 1px;\n    border-radius: 3px;\n    z-index: 200;\n    width: 100%;\n    box-sizing: border-box;\n}\n\n.dropdown li {\n    padding: 1px .5rem;\n}\n\n.dropdown li:hover {\n    background-color: #f0f0f0;\n}\n\n.dropdown-plans-description {\n    width: 21rem;\n}\n\n.dropdown-plans-specifications {\n    margin-right: auto;\n}\n\n.dropdown-plans-price {\n    line-height: 1rem;\n    min-width: fit-content;\n}\n\n.scaler-container {\n    all: unset;\n    display: grid;\n    grid-template-columns: 48px auto 48px;  /* Adjust 'auto' based on the middle content width */\n    grid-template-areas: \"down input up\";\n    min-width: 100px;\n    max-width: 250px;\n}\n\n.stepper-container {\n    all: unset;\n    display: grid;\n    grid-template-columns: auto 36px;\n    grid-template-areas: \"input up\" \"input down\";\n    min-width: 100px;\n    max-width: 150px;\n}\n\n.scaler-input-wrapper,\n.stepper-input-wrapper {\n    grid-area: input;\n}\n\n.scaler-input,\n.stepper-input {\n    width: 100%;\n    min-width: 5rem;\n    display: flex;\n    height: 48px;\n    position: relative;\n    box-sizing: border-box;\n    background-color: rgb(255, 255, 255);\n    cursor: text;\n    padding: 0;\n    gap: 16px;\n    border: 1px solid rgb(91, 105, 135);\n}\n\n.stepper-input {\n    border-radius: 3px 0 0 3px;\n}\n\n.scaler-input-field,\n.stepper-input-field {\n    transition: all 0.25s cubic-bezier(0.645, 0.045, 0.355, 1);\n    box-sizing: border-box;\n    background-color: unset;\n    outline: none;\n    width: 100%;\n    height: 100%;\n    display: block;\n    border: unset;\n    box-shadow: unset;\n    line-height: 1.5;\n    resize: none;\n    text-align: center;\n    padding: 0 16px;\n}\n\n.stepper-input-field {\n    border-radius: 3px 0 0 3px;\n}\n\n.scaler-input-field:focus,\n.stepper-input-field:focus {\n    outline: rgb(91, 105, 135) dotted 2px;\n    outline-offset: 2px;\n    z-index: 2;\n}\n\n.scaler-input-field:hover:not(:disabled),\n.stepper-input-field:hover:not(:disabled) {\n    border-color: rgb(0, 97, 235);\n}\n\n.scaler-input-field:disabled,\n.stepper-input-field:disabled {\n    cursor: unset;\n    opacity: 0.3;\n    outline: none;\n}\n\n/* Remove spinner (up and down arrows) in WebKit-based browsers (e.g., Chrome, Safari) */\n.scaler-input-field::-webkit-inner-spin-button,\n.stepper-input-field::-webkit-inner-spin-button {\n    appearance: none;\n    -moz-appearance: textfield; /* Remove spinner in Firefox */\n}\n\n.scaler-button-wrapper-up,\n.stepper-button-wrapper-up {\n    grid-area: up;\n}\n\n.scaler-button-wrapper-down,\n.stepper-button-wrapper-down {\n    grid-area: down;\n}\n\n.stepper-button-wrapper-down {\n    grid-area: down;\n    border-top: 1px solid rgb(91, 105, 135); /* Keep this border immune to opacity if increment or decrement button is :disabled */\n}\n\n.scaler-button-increment,\n.scaler-button-decrement,\n.stepper-button-increment,\n.stepper-button-decrement {\n    all: unset;\n    width: 100%;\n    height: 100%;\n    position: relative;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    box-sizing: border-box;\n    background-color: rgb(255, 255, 255);\n    cursor: pointer;\n    border-style: solid;\n    border-image: initial;\n    padding: 0;\n    color: rgb(91, 105, 135);\n}\n\n.scaler-button-increment {\n    transition: all 0.25s cubic-bezier(0.645, 0.045, 0.355, 1);\n    border-right: 1px solid rgb(91, 105, 135);\n    border-top: 1px solid rgb(91, 105, 135);\n    border-left: none;\n    border-bottom: 1px solid rgb(91, 105, 135);\n    border-top-right-radius: 3px;\n    border-bottom-right-radius: 3px;\n}\n\n.stepper-button-increment {\n    transition: all 0.25s cubic-bezier(0.645, 0.045, 0.355, 1);\n    border-right: 1px solid rgb(91, 105, 135);\n    border-top: 1px solid rgb(91, 105, 135);\n    border-left: none;\n    border-bottom: none;\n    border-top-right-radius: 3px;\n    border-bottom-right-radius: 0;\n}\n\n.stepper-button-decrement {\n    transition: all 0.25s cubic-bezier(0.645, 0.045, 0.355, 1);\n    border-right: 1px solid rgb(91, 105, 135);\n    border-bottom: 1px solid rgb(91, 105, 135);\n    border-left: none;\n    border-top: none;\n    border-bottom-right-radius: 3px;\n}\n\n.scaler-button-decrement {\n    transition: all 0.25s cubic-bezier(0.645, 0.045, 0.355, 1);\n    border-right: none;\n    border-bottom: 1px solid rgb(91, 105, 135);\n    border-left: 1px solid rgb(91, 105, 135);\n    border-top: 1px solid rgb(91, 105, 135);\n    border-top-left-radius: 3px;\n    border-bottom-left-radius: 3px;\n}\n\n.scaler-button-increment:hover:not(:disabled),\n.scaler-button-decrement:hover:not(:disabled),\n.stepper-button-increment:hover,\n.stepper-button-decrement:hover {\n    background-color: rgb(243, 245, 249);\n}\n\n.scaler-button-increment:focus,\n.scaler-button-decrement:focus,\n.stepper-button-increment:focus,\n.stepper-button-decrement:focus {\n    outline: rgb(91, 105, 135) dotted 2px;\n    outline-offset: 2px;\n    z-index: 2;\n}\n\n.scaler-button-increment:active:not(:disabled),\n.scaler-button-decrement:active:not(:disabled)\n.stepper-button-increment:active:not(:disabled),\n.stepper-button-decrement:active:not(:disabled) {\n    color: rgb(0, 97, 235);\n    border-color: rgb(0, 97, 235);\n    background-color: rgb(243, 248, 255);\n    fill: rgb(0, 97, 235); /* Color for the arrow */\n}\n\n.scaler-button-increment:disabled,\n.scaler-button-decrement:disabled {\n    cursor: unset;\n    fill-opacity: 0.3;\n    outline: none;\n}\n\n\n.stepper-button-increment:disabled,\n.stepper-button-decrement:disabled {\n    cursor: unset;\n    opacity: 0.3;\n    outline: none;\n}\n\n.scaler-icon-up,\n.scaler-icon-down,\n.stepper-icon-up,\n.stepper-icon-down {\n    height: .65em;\n    width: .65em;\n}\n\n.search-container .input {\n    display: block;\n    width: 100%;\n}\n\n.alert-info {\n    height: 1.4em;\n    width: 1.4em;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
